var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaiffeisenbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raiffeisenbank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 12.9995L3.37182 19.6046L0.762124 16.9949L7.36721 10.3667L5.95843 8.98103V6.25586L5.03465 5.28588V7.66463L4.22633 8.49604L0.831408 5.17041L0 5.97872C0.0146189 4.48833 0.611374 3.06275 1.66282 2.00641C3.32563 0.412873 5.12703 1.12881 5.70439 1.75236L9.07621 5.12422L8.2679 5.97872L10 7.71082L11.7783 5.93253L10.9238 5.10112L14.2725 1.70618C14.8447 1.20975 15.5892 0.958167 16.3453 1.00569C17.1014 1.05322 17.8085 1.39604 18.3141 1.96022C19.3684 3.01664 19.9726 4.44027 20 5.93253L19.1686 5.10112L15.8199 8.51913L14.9885 7.68773V5.28588L14.0416 6.25586V8.98103L12.6328 10.3667L19.2379 16.9949L16.6513 19.6046L10 12.9995Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiffeisenbank);
export default __webpack_public_path__ + "static/media/raiffeisenbank.4de7040945e7e430eaf074c898b86c00.svg";
export { ForwardRef as ReactComponent };